<template>
  <div class="bg">
    <div class="vux-1px-b">
      <selector
        title="账户类型"
        direction="rtl"
        v-model="type"
        :options="typeList"
      ></selector>
    </div>
    <div class="vux-1px-b" v-if="type == 1">
      <selector
        title="公司名称"
        direction="rtl"
        v-model="company.companyId"
        :options="companyList"
      ></selector>
    </div>
    <div class="vux-1px-b">
      <selector
        title="提现至"
        direction="rtl"
        v-model="params.bankId"
        :options="bankList"
      ></selector>
    </div>
    <div class="vux-1px-b" style="overflow: hidden">
      <x-input
        title="提现金额"
        text-align="right"
        placeholder="请输入提现金额"
        v-model="params.amount"
        placeholder-align="right"
      ></x-input>
      <div class="cashOut">
        剩余可提现金额￥<span v-if="availableAmount">{{
          availableAmount / 100
        }}</span
        ><span v-else>0</span>
      </div>
    </div>
    <div class="vux-1px-b vux-1px-t" style="margin: 12px 0">
      <div class="flex">
        <x-input
          class="flex1"
          title="验证码"
          text-align="right"
          placeholder="请输入验证码"
          v-model="params.code"
          placeholder-align="right"
        ></x-input>
        <div class="code" :class="{ disabled: isDisable }" @click="getCode">
          {{ getMobileCodeText() }}
        </div>
      </div>
    </div>

    <div class="saveButton" v-if="loadingImg === true">
      <img class="loadingImg" src="../../assets/loading.gif" />
    </div>
    <div class="saveButton" @click="save" v-else>提现</div>
  </div>
</template>

<script>
import { bankActiveList } from "../../api/bank";
import {
  activeBankCompanyList,
  companyBankActiveList,
  companyAccountBalance
} from "../../api/company";
import {
  getRemain,
  getCode,
  withdrawConfirm,
  withdrawStatus
} from "../../api/cashout";

export default {
  name: "cashOut",
  data() {
    return {
      loadingImg: false,
      wait_timer: false,
      isDisable: false,
      availableAmount: "",
      params: {
        bankCard: "",
        amount: "",
        code: "",
        bankId: "",
        withdrawId: "",
        orderId: ""
      },
      bankList: [],
      type: "0",
      typeList: [
        {
          key: "0",
          value: "个人"
        },
        {
          key: "1",
          value: "公司"
        }
      ],
      company: {
        companyId: "",
        name: ""
      },
      companyList: []
    };
  },
  watch: {
    type(e) {
      this.company.companyId = "";
      this.params.bankId = "";
      this.params.bankCard = "";
      if (e == 0) {
        this.fetchBankActiveList();
      } else {
        this.fetchCompanyBankActiveList();
      }
    },
    "params.bankCard"() {
      if (this.params.bankCard) {
        if (this.type == 0) {
          this.getRemain();
        } else {
          this.getCompanyAccountBalance();
        }
      }
    }
  },
  created() {
    this.fetchBankActiveList();
  },
  methods: {
    fetchCode() {
      getCode({
        bankId: this.params.bankId,
        amount: parseFloat(this.params.amount)
      })
        .then(res => {
          this.params.withdrawId = res.withdrawId;
        })
        .catch(err => {
          this.$showError(err);
          this.wait_timer = false;
        });
    },
    getRemain() {
      getRemain()
        .then(res => {
          this.availableAmount = res.availableAmount;
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    fetchBankActiveList() {
      bankActiveList({ clientId: this.$store.state.user.userInfo.id })
        .then(res => {
          this.bankList = res.map(x => {
            return {
              key: x.id,
              value: x.accountNumber
            };
          });
          if (this.bankList.length > 0) {
            this.params.bankCard = this.bankList[0].value;
            this.params.bankId = this.bankList[0].key;
          }
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    fetchCompanyBankActiveList() {
      activeBankCompanyList({ clientId: this.$store.state.user.userInfo.id })
        .then(res => {
          this.companyList = res.map(x => {
            return {
              key: x.id,
              value: x.name
            };
          });
          if (this.companyList.length > 0) {
            this.company.companyId = this.companyList[0].key;
            this.company.name = this.companyList[0].value;
            this.getCompanyBankActiveList();
          } else {
            this.bankList = [];
          }
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    getCompanyBankActiveList() {
      companyBankActiveList({ clientId: this.$store.state.user.userInfo.id })
        .then(res => {
          if (res.length > 0) {
            this.bankList = res.map(x => {
              return {
                key: x.id,
                value: x.accountNumber
              };
            });
          } else {
            this.bankList = [];
          }
          this.$nextTick(() => {
            if (this.bankList.length > 0) {
              this.params.bankCard = this.bankList[0].value;
              this.params.bankId = this.bankList[0].key;
            }
          });
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    getCompanyAccountBalance() {
      companyAccountBalance({ companyId: this.company.companyId })
        .then(res => {
          this.availableAmount = res.availableAmount;
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    getCode() {
      let that = this;
      if (this.type == 0) {
        if (!this.params.bankCard) {
          alert("请选择银行卡");
        } else if (!this.params.amount) {
          alert("请输入提现金额");
        } else {
          this.wait_timer = 59;
          this.isDisable = true;
          let timer_interval = setInterval(function() {
            if (that.wait_timer > 0) {
              that.wait_timer--;
            } else {
              that.isDisable = false;
              clearInterval(timer_interval);
            }
          }, 1000);
          this.fetchCode();
        }
      } else {
        if (!this.params.bankCard) {
          alert("请选择银行卡");
        } else if (!this.params.companyId) {
          alert("请输入提现金额");
        } else if (!this.params.amount) {
          alert("请输入提现金额");
        } else {
          this.wait_timer = 59;
          this.isDisable = true;
          let timer_interval = setInterval(function() {
            if (that.wait_timer > 0) {
              that.wait_timer--;
            } else {
              that.isDisable = false;
              clearInterval(timer_interval);
            }
          }, 1000);
          this.fetchCode();
        }
      }
    },
    getMobileCodeText() {
      if (this.wait_timer > 0) {
        return this.wait_timer + "s后获取";
      }
      if (this.wait_timer === 0) {
        return "重新获取";
      }
      if (this.wait_timer === false) {
        return "获取验证码";
      }
    },
    save() {
      this.loadingImg = true;
      withdrawConfirm({
        validateCode: this.params.code,
        withdrawId: this.params.withdrawId
      })
        .then(res => {
          this.params.orderId = res.orderNo;
          withdrawStatus({ orderId: this.params.orderId })
            .then(res => {
              if (res.orderStatus === 1002) {
                this.$showMessage("提现成功");
                this.loadingImg = false;
                this.getRemain();
                this.params.bankCard = "";
                this.params.amount = "";
                this.params.code = "";
                this.params.bankId = "";
                this.params.withdrawId = "";
                this.params.orderId = "";
              } else {
                this.$showMessage("提现失败");
                this.loadingImg = false;
              }
            })
            .catch(err => {
              this.$showError(err);
              this.loadingImg = false;
            });
        })
        .catch(err => {
          this.$showError(err);
          this.loadingImg = false;
        });
    }
  }
};
</script>

<style scoped>
.disabled {
  pointer-events: none;
}
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
.bg {
  overflow: hidden;
  font-size: 14px;
}
.code {
  width: 200px;
  height: 46px;
  line-height: 46px;
  background-color: #fff;
  border: 1px solid #039df8;
  color: #039df8;
  display: block;
  margin: 18px 20px;
  border-radius: 25px;
  float: right;
  font-size: 12px;
  text-align: center;
}
.saveButton {
  margin: 50px 30px;
  background: #039df8;
  height: 86px;
  line-height: 86px;
  text-align: center;
  border-radius: 10px;
  color: #fff;
  font-size: 16px;
  letter-spacing: 10px;
}
.loadingImg {
  width: 32px;
  height: 32px;
  line-height: 86px;
}
.cashOut {
  font-size: 12px;
  line-height: 28px;
  overflow: hidden;
  padding: 30px 0px;
  margin-left: 30px;
  border-top: 1px solid #e8e8e8;
  color: #474747;
}
.vux-1px-b {
  background: #fff;
}
</style>
